import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import styles from './HeaderPanel.module.css';
import type AssistantViewController from '../AssistantView/AssistantViewController';
import classNames from 'classnames';
import HeaderButtons from './HeaderButtons';

const HeaderPanel = () => {
  const controller = useController<AssistantViewController>();
  const { size, readOnly } = controller.state;
  const isFullPage = size === 'full-page';
  const isFullScreen = ['full-screen', 'full-page'].includes(size);

  return (
    <div
      className={classNames(styles.header, {
        [styles.fullScreen]: isFullScreen,
      })}
    >
      <span className={styles.headerTitle}>
        <aha-ai-icon />
        <span className={styles.assistantName}>AI assistant</span>
        {controller.state.model.currentChat.id && (
          <span className={styles.headerAgentName}>
            {controller.agent.publicName()}
          </span>
        )}
      </span>
      {!isFullPage && !readOnly && <HeaderButtons />}
    </div>
  );
};

export default ApplicationView(HeaderPanel);
